/**
 * Cookie banner — show until the user accepts or declines, then remember
 * the choice in localStorage. Banner markup is rendered hidden in PHP
 * (`<aside data-prlab-cookie hidden>`); we reveal it after a short delay
 * to avoid layout shift on first paint.
 */

const STORAGE_KEY = 'prlab_cookie_consent';

export function initCookieBanner() {
  const banner = document.querySelector('[data-prlab-cookie]');
  if (!banner) return;

  let stored = null;
  try {
    stored = window.localStorage.getItem(STORAGE_KEY);
  } catch (_) {
    // Private mode etc — fall through to show banner once per page load.
  }
  if (stored === 'accept' || stored === 'decline') {
    banner.remove();
    return;
  }

  banner.hidden = false;
  // Defer the visible class to enable the slide-up transition.
  requestAnimationFrame(() => banner.classList.add('is-visible'));

  banner.addEventListener('click', (e) => {
    const btn = e.target.closest('[data-prlab-cookie-action]');
    if (!btn) return;
    const action = btn.getAttribute('data-prlab-cookie-action');
    try {
      window.localStorage.setItem(STORAGE_KEY, action);
    } catch (_) {
      // Ignore — we still hide the banner this session.
    }
    banner.classList.remove('is-visible');
    setTimeout(() => banner.remove(), 360);
  });
}
